import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, ElementRef, Inject, NgModule, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router, RouterModule } from '@angular/router';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';
import { Component as ComponentInfo } from '@app/models/component';
import { ComponentState } from '@app/models/component-state';
import { LinkModule } from '@app/directives/link.directive';
import { ComponentStatesOnRoutesService } from '@app/services/component-states-on-routes.service';
import { Environment } from '@environments/interface.environment';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-skip-links',
  templateUrl: './skip-links.component.html',
  styleUrls: ['./skip-links.component.scss']
})
export class SkipLinksComponent implements OnInit, OnDestroy {
  subscriptions = new Subscription();
  skipLinks: ComponentState[];
  dynamicSkipLinks: ComponentState[];
  staticSkipLinks: ComponentState[];

  constructor(private router: Router,
              private componentEventService: ComponentStatesOnRoutesService,
              public elementRef: ElementRef,
              @Inject(CUSTOMERENVIRONMENT) private environment: Environment,
              @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.staticSkipLinks = this.environment.featureSettings.staticSkipLinks ? this.environment.featureSettings.staticSkipLinks.Sections.map(section => {
      return new ComponentState({
        ShowBadge: false,
        ComponentId: section.Id,
        Component: new ComponentInfo({
          Title: section.Name,
          Id: section.Id
        })
      });
    }) : [];

    this.subscriptions.add(
      this.router.events
        .pipe(filter(event => event instanceof NavigationStart))
        .subscribe((event: NavigationStart) => {
          if (event.url.indexOf('#') === -1) {
            this.dynamicSkipLinks = this.componentEventService.state.RouteMap.has(event.url)
              && this.componentEventService.state.RouteMap.get(event.url);
            if (this.dynamicSkipLinks && this.dynamicSkipLinks.length > 0) {
              this.skipLinks = [...this.staticSkipLinks, ...this.dynamicSkipLinks];
            }
          }
        })
    );
  }

  skipToContent(elementId) {
    const element = this.document.getElementById(elementId);

    if (element) {
      if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) {
        element.tabIndex = -1;
      }
      element.focus();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}

@NgModule({
  declarations: [SkipLinksComponent],
  exports: [SkipLinksComponent],
  imports: [
    CommonModule,
    LinkModule,
    RouterModule,
  ]
})
export class SkipLinksModule { }
